import React from 'react'

interface HighlightTextProps {
    text: string
    searchQuery: string
    className?: string
    highlightClassName?: string
}

const HighlightText: React.FC<HighlightTextProps> = ({
    text,
    searchQuery,
    className = '',
    highlightClassName = 'bg-yellow-200 font-medium',
}) => {
    if (!searchQuery || !text) {
        return <span className={className}>{text}</span>
    }

    // Escape special regex characters
    const escapeRegExp = (string: string) => {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    }

    const regex = new RegExp(`(${escapeRegExp(searchQuery)})`, 'gi')
    const parts = text.split(regex)

    return (
        <span className={className}>
            {parts.map((part, index) =>
                regex.test(part) ? (
                    <mark key={index} className={highlightClassName}>
                        {part}
                    </mark>
                ) : (
                    part
                )
            )}
        </span>
    )
}

export default HighlightText
